<template>
  <page-outline :title="$t('common.routing.flagCACP.entity_group.page')">
    <template slot="pageContent">
      <div class="listPage ml-3 mr-3">
        <b-row class="justify-content-start mb-5">
          <b-col cols="4" lg="2" xl="1">
            <back-button :returnUrl="returnUrl"></back-button>
          </b-col>
        </b-row>
        <!-- Bouton de rafraîchissement -->
        <b-row class="justify-content-start">
          <b-col cols="6" lg="3" xl="2" class="mb-5">
            <b-button class="btnFilter"
              @click="displayFilter = !displayFilter">
              <i v-if="displayFilter" class="fa-light fa-minus"></i>
              <i v-else class="fa-light fa-plus"></i>
              {{ $t('filter.fltr') }}
            </b-button>
          </b-col>
          <b-col cols="6" lg="3" xl="2" class="mb-5">
            <b-button
              class="btnFilter"
              :disabled="activateSpinner"
              @click="onRefresh()">
              <i class="fa-light fa-rotate-right fs-14px"></i>
            {{ $t('common.rfrsh') }}
            </b-button>
          </b-col>
          <b-col cols="6" lg="6" xl="4" class="mb-5">
            <b-button variant="primary"
              @click="actionAdd">
              <i class="fa-light fa-plus"></i>
              <span>{{$t('common.routing.flagCACP.entity_group.add')}}</span>
            </b-button>
          </b-col>
        </b-row>
        <b-row class="justify-content-start align-items-center" :class="{'filter-item-section':true, 'd-none': !displayFilter}">
          <!-- Filtre Name -->
          <b-col sm="6" lg="3" cols="12" class="filter-item mb-5">
            <label class="filter-item-title" for="filter-name">{{ $t('common.routing.flagCACP.entity_group.name') }}</label>
            <span class="filter-item-content">
              <input v-model.trim="Name"
                id="filter-name"
                type="text"
                :class="{'filter-item-input': true, 'filter-item-input-complete': Name}"
                :placeholder="$t('common.routing.flagCACP.entity_group.name')"
                style="width: 100%">
            </span>
          </b-col>
        </b-row>

        <b-row class="justify-content-end" v-if="displayFilter">
          <!-- Boutons Effacer et Appliquer -->
          <b-col sm="4" lg="2" cols="12" class="mt-4 mb-5">
            <b-button class="mr-3" size="sm"
                      @click="clearFilterFields" :disabled="activateSpinner">
              {{ $t('filter.clr_fltr_field') }}
            </b-button>
          </b-col>
          <b-col sm="4" lg="2" cols="12" class="mt-4 mb-5">
            <b-button class="btn" size="sm"
                      @click="onRefresh">
              {{ $t('common.srch') }}
            </b-button>
          </b-col>
        </b-row>
        <b-row class="mb-5">
          <b-col cols="12">
            <div style="overflow:auto">
              <spinner v-if="activateSpinner"></spinner>
              <b-table v-else-if="entityGroupList.length > 0"
                :items="entityGroupList"
                :fields="fields"
                class="table-striped"
                hover
                :selectable="entityGroupList.length > 0"
                :empty-text="$t('common.security.no_result')"
                style="margin-bottom:0"
                @row-selected="onRowClicked"
                :key="refreshKey">
                <template #cell(Name)="data">
                  <span>{{ data.value }}</span>
                </template>
                <template #cell(edit)="data">
                  <span class="text-center d-inline-block py-3 w-100" @click="actionEdit($event, data.item.IdEntityGroup)">
                    <i class="fa-regular fa-pencil"></i>
                  </span>
                </template>
                <template #cell(delete)="data">
                  <span class="text-center d-inline-block py-3 w-100" @click="actionDelete($event, data.item.IdEntityGroup)">
                    <i class="fa-regular fa-trash"></i>
                  </span>
                </template>
              </b-table>
              <div v-else class="d-flex justify-content-center">
                <span class="noResult">
                  {{ $t('common.no_result') }}
                </span>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </template>
  </page-outline>
</template>

<script>
import formWriteGroupLabelInput from "@/components/common/formWriteGroupLabelInput.vue"
import PageOutline from "@/components/common/PageOutline.vue"
import Spinner from "@/components/common/spinner.vue"
import { errorMessageAlert } from "@/helpers/alert"
import { loadPage } from "@/helpers/routing"
import backButton from "@/components/common/backButton.vue"

export default {
  name: "EntityGroupList",
  components: {
    'back-button': backButton,
    "form-write-group-label-input": formWriteGroupLabelInput,
    "page-outline": PageOutline,
    spinner: Spinner
  },
  data() {
    return {
      activateSpinner: false,
      displayFilter: false,
      filterConditions: {},
      EntityGroupList: [],
      Name: '',
      refreshKey: false,
      returnUrl: ''
    }
  },
  created() {
    this.returnUrl = '/entitiessettings/requester/Corporate'
    this.activateSpinner = true

    this.$f7.initPullToRefresh()

    this.getEntityGroup()
  },
  computed: {
    canDelete () {
      return this.$engine.firstOn().rights.rightIs('entityGroup_delete', true)
    },
    canEdit () {
      return this.$engine.firstOn().rights.rightIs('entityGroup_edit', true)
    },
    fields () {
      let fields = []
      fields.push({
        key: 'Name',
        label: this.$t('common.routing.flagCACP.entity_group.name'),
        class: 'text-center',
        sortable: true
      })
      if (this.canEdit) {
        fields.push({ key: 'edit', label: this.$t('common.edit_label'), class: 'text-center', sortable: false })
      }
      if (this.canDelete) {
        fields.push({ key: 'delete', label: this.$t('common.del_label'), class: 'text-center', sortable: false })
      }
      return fields
    }
  },
  methods: {
    actionAdd () {
      loadPage(this, {url: '/entityGroup/add/-1'})
    },
    actionDelete ($e, id) {
      $e.stopPropagation()
      let that = this
      this.$f7.modal({
        title: this.$t('common.routing.flagCACP.entity_group.deletion_confirm'),
        buttons: [
          {
            text: this.$t('creation_forms.vldt'),
            onClick: function () {
              let params = { IdEntityGroup: id }
              that.$engine.firstOn().entityGroup.deleteEntityGroup(params)
              .then(resp => {
                that.entityGroupList = that.entityGroupList.filter(item => item.IdEntityGroup !== id)
                that.$f7.modal({
                  title: that.$t('common.routing.flagCACP.entity_group.deleted'),
                  buttons: [
                    { text: 'OK', onClick: function () { return } }
                  ]
                })
                that.onRefresh()
              })
              .catch((e) => {
                if (e.response.status === 400 && e.response.data.errors) {
                  const errors = e.response.data.errors

                  errors.forEach((error) => {
                    if (error.error === "IdEntityGroup used") {
                      that.okMessageBox(error.errorDescription)
                    }
                  })
                } else {
                    errorMessageAlert(e, that, that.$i18n)
                }
              })
            }
          },
          {
            text: this.$t('common.cncl'),
            onClick: function () { return }
          }
        ]
      })
    },
    actionEdit ($e, id) {
      $e.stopPropagation()
      loadPage(this, { url: '/entityGroup/edit/' + id })
    },
    clearFilterFields() {
      this.Name = ''
    },
    getEntityGroup(index = 1) {
      let that = this
      let params = {
        Name: this.Name
      }
      this.$engine.firstOn().entityGroup.getEntityGroup(params).then((resp) => {
        that.entityGroupList = resp.data.EntityGroup

        this.$f7.pullToRefreshDone()
        that.activateSpinner = false
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    okMessageBox (message) {
      this.$f7.modal({
        title: message,
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    onRefresh() {
      this.refreshKey = !this.refreshKey
      this.activateSpinner = true
      this.getEntityGroup()
    },
    onRowClicked(item) {
      if (item[0] && item[0].IdEntityGroup) {
        loadPage(this, { url: '/entityGroup/details/' + item[0].IdEntityGroup })
      }
    }
  }
}
</script>
